import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import qs from "qs";
import "@/style/index.less";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
import "font-awesome/css/font-awesome.min.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/style/element-variables.scss";
import "@/assets/iconfont1/iconfont.css";
import "@/assets/iconfont1/iconfont.js";
import ElementUI from "element-ui";
// import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueECharts from "vue-echarts/components/ECharts.vue";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/chart/scatter";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.min";
import Datatable from "vue2-datatable-component";
import locale_zh from "vue2-datatable-component/locale/zh-cn";
//import locale_default from "vue2-datatable-component/locale/pt-br";
import _ from "lodash";
import less from "less";
import i18n from "./components/I18n";
import "./directive";
import VueWorker from "vue-worker";
import { getCLS, getFID, getLCP, getFCP, getTTFB } from "web-vitals";
import ErrorStackParser from "error-stack-parser";
import { clientError } from "@/api/public";
import { getBaseErrorObj } from "@/utils/index.js";
Vue.use(VueWorker);
Vue.use(less);
Vue.prototype._ = _;
Vue.prototype.$qs = qs;
Vue.prototype.$eventBus = new Vue();
Vue.config.productionTip = false;
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
Vue.prototype.$axios = axios;
// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);
let local_datatable = {};
local_datatable.locale = locale_zh;
Vue.use(Datatable, local_datatable); //{ locale: locale_zh });
Vue.component("v-chart", VueECharts);
// const compomentArr = [
//   "Search",
//   "TopHeader",
//   "MainHeader",
//   "BaseInfo",
//   "TalentList",
//   "BrandList",
//   "CustomList",
//   "CrowdScene",
//   "CrowdPortrait",
//   "TopicAnalysis",
//   "AiInterpret",
//   "LoadProject",
//   "CustomManage",
//   "Setting",
// ];
// Vue.mixin({
//   beforeCreate() {
//     if (this.$options.name && compomentArr.includes(this.$options.name)) {
//       performance.mark(`component-${this.$options.name}-start`);
//     }
//   },
//   mounted() {
//     if (this.$options.name && compomentArr.includes(this.$options.name)) {
//       const componentName = this.$options.name;
//       performance.mark(`component-${componentName}-end`);
//       performance.measure(
//         `component-${componentName}`,
//         `component-${componentName}-start`,
//         `component-${componentName}-end`
//       );
//     }
//   },
// });
function sendToAnalytics(metric) {
  console.log("[Web Vitals]", metric);
  const obj = {
    TTFB: 600, //首字节时间，从浏览器发起请求到接收到服务器第一个字节的时间。
    FCP: 1800, //首次内容绘制,浏览器首次渲染 任何文本、图片（包括背景图）、非空白 canvas 或 SVG 的时间点
    LCP: 2500, //最大内容渲染时间，视窗内最大内容元素（如标题、主图、视频等）完成渲染的时间
    CLS: 0.1, //累计布局偏移，页面生命周期内所有意外布局偏移的累计分数（偏移距离 × 影响范围）
    INP: 200, //交互至下一次渲染,测量所有用户交互的延迟
    FID: 100, //首次输入延迟,记录用户首次点击、触摸或键盘输入时的延迟，反映主线程的繁忙程度
  };
  if (
    Object.keys(obj).includes(metric.name) &&
    metric.value > obj[metric.name]
  ) {
    const baseObj = getBaseErrorObj();
    baseObj.error_msg = `${metric.name}:${metric.value}`;
    clientError(baseObj);
  }
}
getTTFB(sendToAnalytics);
getFCP(sendToAnalytics);
getLCP(sendToAnalytics);
getCLS(sendToAnalytics);
getFID(sendToAnalytics);

Vue.config.errorHandler = function (err, vm, info) {
  console.log("Error: ", err, "Vue Instance: ", vm, "Info: ", info);
  const parsedError = ErrorStackParser.parse(err);
  console.log(err.name, err.message, parsedError);
  const baseObj = getBaseErrorObj();
  baseObj.error_msg = err.message;
  baseObj.stackTrace = parsedError;
  clientError(baseObj);
  // Send error information to a logging service
};
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
